export const DESK_NUMBER = 3;
// eslint-disable-next-line no-shadow
export var EMatchStatus;
(function (EMatchStatus) {
    EMatchStatus[EMatchStatus["CREATED"] = 0] = "CREATED";
    EMatchStatus[EMatchStatus["INGAME"] = 1] = "INGAME";
    EMatchStatus[EMatchStatus["ENDED"] = 2] = "ENDED";
    EMatchStatus[EMatchStatus["CANCELLED"] = 3] = "CANCELLED";
    EMatchStatus[EMatchStatus["FAILED"] = 4] = "FAILED";
})(EMatchStatus || (EMatchStatus = {}));
export const getMatchStatusString = (status) => {
    switch (status) {
        case EMatchStatus.CREATED:
            return 'Создана';
        case EMatchStatus.CANCELLED:
            return 'Отменена';
        case EMatchStatus.ENDED:
            return 'Завершена';
        case EMatchStatus.FAILED:
            return 'Ошибка';
        case EMatchStatus.INGAME:
            return 'В игре';
        default:
            return 'Не удалось определить';
    }
};
// eslint-disable-next-line no-shadow
export var EGamePhase;
(function (EGamePhase) {
    EGamePhase[EGamePhase["DAY"] = 0] = "DAY";
    EGamePhase[EGamePhase["NIGHT"] = 1] = "NIGHT";
})(EGamePhase || (EGamePhase = {}));
// eslint-disable-next-line consistent-return
export const getGamePhaseString = (phase) => {
    // eslint-disable-next-line default-case
    switch (phase) {
        case EGamePhase.DAY:
            return 'День';
        case EGamePhase.NIGHT:
            return 'Ночь';
    }
};
// eslint-disable-next-line no-shadow
export var EGameStatus;
(function (EGameStatus) {
    EGameStatus[EGameStatus["GAME_ROLE_SETTING_NIGHT"] = 0] = "GAME_ROLE_SETTING_NIGHT";
    EGameStatus[EGameStatus["SELECT_WHO_START_INTRODUCE"] = 1] = "SELECT_WHO_START_INTRODUCE";
    EGameStatus[EGameStatus["PLAYER_INTRODUCING"] = 2] = "PLAYER_INTRODUCING";
    EGameStatus[EGameStatus["SELECT_DIRECTION_OF_INTRODUCE"] = 3] = "SELECT_DIRECTION_OF_INTRODUCE";
    EGameStatus[EGameStatus["INTRODUCE_YOURSELF_STATE"] = 4] = "INTRODUCE_YOURSELF_STATE";
    EGameStatus[EGameStatus["SELECT_WHO_START_VOTING"] = 5] = "SELECT_WHO_START_VOTING";
    EGameStatus[EGameStatus["PLAYER_VOTING"] = 6] = "PLAYER_VOTING";
    EGameStatus[EGameStatus["SELECT_DIRECTION_OF_VOTE"] = 7] = "SELECT_DIRECTION_OF_VOTE";
    EGameStatus[EGameStatus["PLAYER_VOTE_STATE"] = 8] = "PLAYER_VOTE_STATE";
    EGameStatus[EGameStatus["RUSSIAN_ROULETTE_STATE"] = 9] = "RUSSIAN_ROULETTE_STATE";
    EGameStatus[EGameStatus["DAY_RESULT_SHOW_STATE"] = 10] = "DAY_RESULT_SHOW_STATE";
    EGameStatus[EGameStatus["SELECT_ROLE_TO_WAKE_UP"] = 11] = "SELECT_ROLE_TO_WAKE_UP";
    EGameStatus[EGameStatus["ROLE_PERFORM_NIGHT_ACTION"] = 12] = "ROLE_PERFORM_NIGHT_ACTION";
    EGameStatus[EGameStatus["NIGHT_RESULT_SHOW_STATE"] = 13] = "NIGHT_RESULT_SHOW_STATE";
    EGameStatus[EGameStatus["FINAL_RESULT"] = 14] = "FINAL_RESULT";
    EGameStatus[EGameStatus["BACHELOR_IS_SELECTING"] = 15] = "BACHELOR_IS_SELECTING";
    EGameStatus[EGameStatus["SHERIFF_CHECK_RESULT_STATE"] = 16] = "SHERIFF_CHECK_RESULT_STATE";
})(EGameStatus || (EGameStatus = {}));
export const getGameStatusString = (status) => {
    switch (status) {
        case EGameStatus.GAME_ROLE_SETTING_NIGHT:
            return 'Задай роли';
        case EGameStatus.SELECT_WHO_START_INTRODUCE:
            return 'Кто начнет представление?';
        case EGameStatus.PLAYER_INTRODUCING:
            return 'Представление';
        case EGameStatus.SELECT_DIRECTION_OF_INTRODUCE:
            return 'Кто следующий?';
        case EGameStatus.INTRODUCE_YOURSELF_STATE:
            return 'Представление';
        case EGameStatus.SELECT_WHO_START_VOTING:
            return 'Кто начнет голосование?';
        case EGameStatus.PLAYER_VOTING:
            return 'Голосование';
        case EGameStatus.SELECT_DIRECTION_OF_VOTE:
            return 'Кто следующий?';
        case EGameStatus.PLAYER_VOTE_STATE:
            return 'Голосование';
        default:
            return '';
    }
};
// eslint-disable-next-line no-shadow
export var TGamePhaseEventType;
(function (TGamePhaseEventType) {
    TGamePhaseEventType["KILL"] = "KILL";
    TGamePhaseEventType["SAVED_BY_LADY"] = "SAVED_BY_LADY";
})(TGamePhaseEventType || (TGamePhaseEventType = {}));
